export const ScatterStyles = () => {
    return {
        "& .section--scatter-data": {
            "& .highcharts-data-table": {
                th: {
                    width: "300px",
                },
                td: {
                    textAlign: "center"
                }
            }
        },
        "& .highcharts--scatter-chart ": {
            "& .to-back": {
                zIndex: 1,
            }
        },
        "& .scatter-tools": {
            alignItems: "center",
            display: "flex",
            padding: "0 16px",
            "& .control-labels": {
                marginRight: "2px",
            },
            ".MuiFormGroup-root": {
              marginRight: "1px",
            },
            "& label .MuiFormControlLabel-label": {
                fontSize: "14px",
            },
        },
    }
}